import { render, staticRenderFns } from "./ModalAddQuotaCard.vue?vue&type=template&id=23084a04&"
import script from "./ModalAddQuotaCard.vue?vue&type=script&lang=js&"
export * from "./ModalAddQuotaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports